import React, { Component } from 'react'
import _ from 'lodash'
import { observer, inject } from 'mobx-react'
import { Row, Col, Modal } from 'antd'
import { compose } from 'recompose'
import moment from 'moment'
import BarangayLogo from '../../../components/Custom/BarangayLogo'
import MunicipalLogo from '../../../components/Custom/MunicipalityLogo'
import UserAvatar from '../../../components/Custom/UserAvatar'
import BarangayName from '../../../components/Custom/BarangayName'
import MunicipalName from '../../../components/Custom/MunicipalName'
import MunicipalAddress from '../../../components/Custom/MunicipalAddress'
import QRCode from 'qrcode.react'
import domtoimage from 'dom-to-image'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isDownloading: false
		}
        
		this.handleDownload = this.handleDownload.bind(this)
	}
    
	handleDownload(e) {
		e.preventDefault()
		const { officer } = this.props

		const visitorSplittedName = officer.full_name.split(' ')
		const visitorFirstname = visitorSplittedName[0]
		const visitorLastName = visitorSplittedName[visitorSplittedName.length - 1]
		const visitorFilename = `ID_${visitorFirstname}${visitorLastName.substring(0,1)}_${moment().format('YYYYMMDDHHmmss')}`
        
		this.setState({ isDownloading: true }, () => {
			var that = this
			var node = document.getElementById('staff-id-template')
			domtoimage.toPng(node)
				.then(function (dataUrl) {
					let downloadLink = document.createElement('a')
					downloadLink.href = dataUrl
					downloadLink.download = `${visitorFilename}.png`
					document.body.appendChild(downloadLink)
					downloadLink.click()
					document.body.removeChild(downloadLink)

					that.setState({ isDownloading: false })
				})
				.catch(function (error) {
					console.error('oops, something went wrong!', error)
					that.setState({ isDownloading: false })
				})
		})
		
	}

	render() {
		const { isDownloading } = this.state 
		const { visible, onCancel, officer } = this.props
		const qrCodeData = {
			uid: officer.uid,
			full_name: officer.full_name,
			user_type: 'EMPLOYEE'
		}
		return (
			<React.Fragment>
				 <Modal
				 	title={`ID Template for ${officer.full_name}`}
					width='30%'
					visible={visible}
					onCancel={onCancel}
					footer={null}
				>
					<Row type='flex' justify='center'>
						<div
							id='staff-id-template'
							className='id-staff-background'
							style={{ 
								width: '4.2in',
								height: '6in',
								border: '1px dashed gray',
								borderRadius: '15px',
								// color: '#333333'
								color: 'black'
							}}
						>
							<Row gutter={16}>
								<BarangayLogo width={260} height='auto' style={{
									position: 'absolute',
									left: 65,
									top: 310,
									opacity: 0.1
								}}/>
								<Col md={4} sm={24}>
									<BarangayLogo width={70} height='auto' style={{
										position: 'absolute',
										left: 22,
										top: 17
									}}/>
								</Col>
								<Col md={16} sm={24} style={{ textAlign: 'center', color: 'black' }}>
									<Row style={{ marginTop: 10 }}>
                                        REPUBLIC OF THE PHILIPPINES
									</Row>
									<Row>
										PROVINCE OF <MunicipalAddress isUpperCase={true} />
									</Row>
									<Row>
										<MunicipalName isUpperCase={true} />
									</Row>
									<Row style={{ marginTop: 10 }}>
										<span style={{ fontSize: '22px', fontWeight: 'bold', fontFamily: 'DMSerif' }}>BARANGAY <BarangayName isUpperCase={true} /></span>
									</Row>
								</Col>
								<Col md={4} sm={24}>
									<MunicipalLogo width={70} height='auto' style={{
										position: 'absolute',
										right: 22,
										top: 17
									}}/>
								</Col>
							</Row>
							<hr style={{ marginTop: 1, marginLeft: 30, marginRight: 30, backgroundColor: 'black', height: '0.5mm', border: 'none' }} />
							<Row style={{ marginTop: 20 }}>
								<Col md={12} sm={24}>
									<div style={{ border: '2px solid gray', marginLeft: 30, width: 164 }}>
										<UserAvatar size={160} shape='square' user_uid={officer.uid} />
									</div>
								</Col>
								<Col md={12} sm={24}>
									<Row style={{ textAlign: 'center' }}>
										<QRCode 
											id='generated-qr' 
											value={JSON.stringify(qrCodeData)}
											size={110}
											level={'H'}
											includeMargin={false}
										/>
									</Row>
									<Row style={{ textAlign: 'center' }}>
										<span style={{ fontFamily: 'DMSerif', color: 'black', fontSize: '18px' }}>{officer.id_number}</span>
									</Row>
									<Row style={{ textAlign: 'center', borderTop: '1px solid black', marginLeft: 30, marginRight: 30 }}>
										<small>ID NO</small>
									</Row>
								</Col>
							</Row>
							<Row style={{ textAlign: 'center', marginTop: 20 }}>
								<span style={{ fontFamily: 'DMSerif', color: 'black', fontSize: '24px' }}>{officer.full_name.toUpperCase()}</span>
							</Row>
							<Row style={{ textAlign: 'center', borderTop: '1px solid black', marginLeft: 30, marginRight: 30 }}>
								<small>NAME</small>
							</Row>
							<Row style={{ textAlign: 'center', marginTop: 20 }}>
								<span style={{ fontFamily: 'DMSerif', color: 'black', fontSize: '24px' }}>{officer.position_name.toUpperCase()}</span>
							</Row>
							<Row style={{ textAlign: 'center', borderTop: '1px solid black', marginLeft: 30, marginRight: 30 }}>
								<small>DESIGNATION</small>
							</Row>
							<Row style={{ textAlign: 'center', marginTop: 50 }}>
								<span style={{ fontFamily: 'DMSerif', color: 'black', fontSize: '24px' }}></span>
							</Row>
							<Row style={{ textAlign: 'center', borderTop: '1px solid black', marginLeft: 30, marginRight: 30 }}>
								<small>SIGNATURE</small>
							</Row>
						</div>
					</Row>
					<Row type='flex' justify='center' style={{ marginTop: 20 }}>
						<button disabled={isDownloading} onClick={this.handleDownload} className='btn btn-primary btn-rounded waves-effect waves-light'>Download Image</button>
					</Row>
				</Modal>
			</React.Fragment>
		)
	}
}

const composed = compose(
	inject('AuthStore'),
	observer
)

export default composed(Index)
